import {useEffect, useState} from "react";
import {findUnattendedAccessTermsVersionsWithPagination} from "../api/unattendedAccessTermsVersionApiClient";

export const useUnattendedAccessTermsVersions = (page, pageSize, reloadTrigger) => {
    const [unattendedAccessTermsVersions, setUnattendedAccessTermsVersions] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const unattendedAccessTermsVersionsWithPagination = findUnattendedAccessTermsVersionsWithPagination(page, pageSize, abortController.signal);

        unattendedAccessTermsVersionsWithPagination
            .then(
                (data) => {
                    const unattendedAccessTermsVersions = data.unattendedAccessTermsVersions;
                    const pagination = data.pagination;

                    setUnattendedAccessTermsVersions(unattendedAccessTermsVersions)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [page, pageSize, reloadTrigger]);

    return {unattendedAccessTermsVersions : unattendedAccessTermsVersions, pagination};
};
